// @flow

import React from 'react'
import classNames from 'classnames'
import { useIntl } from 'gatsby-plugin-intl'
import { FormattedMessageSanitized } from '../../FormattedMessageSanitized'
import { Row, Col } from '../../../components/basic/Grid'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import ContactsBlock from '../../../components/basic/ContactsBlock'

import messages from './Contacts.lang'
import baseStyles from './Contacts.scss'

type Props = {
  ...StyleProps
}

const Contacts = ({ styles }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <Row className={styles.root}>
      <Col lg="6">
        <div className={styles.panel}>
          <ContactsBlock styles={styles.contacts} />
          <dl className={styles.list}>
            <dt className={styles.listKey}>{formatMessage(messages.ceo)}:</dt>
            <dd className={styles.listValue}>Tom Hülser</dd>
          </dl>
          <dl className={styles.list}>
            <dt className={styles.listKey}>{formatMessage(messages.register)}:</dt>
            <dd className={styles.listValue}>Registergericht Düsseldorf HRB 56632</dd>
          </dl>
          <dl className={styles.list}>
            <dt className={styles.listKey}>{formatMessage(messages.idnumber)}:</dt>
            <dd className={styles.listValue}>DE255631480</dd>
          </dl>
        </div>
      </Col>
      <Col lg="6" className={styles.welcomeInfo}>
        <FormattedMessageSanitized tagName="div" {...messages.info} />
        <a
          href={formatMessage(messages.dataPrivacyPdfPath)}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          <span className={classNames(styles.linkIcon, 'icon-right')} />
          {formatMessage(messages.infoLink)}
        </a>
      </Col>
    </Row>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(Contacts)
